angular.module('cpm').config(($routeProvider) => {
    'use strict';
    $routeProvider
        .when('/admin', {
            templateUrl: 'admin/admin-user.html',
            title: 'User Admin',
            controller: 'ClientAdminUserCtrl as admin',
            role: 'CLIENTADMIN'
        });
});
